import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import Loader from "../reusable Component/Loader";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import VerifiedIcon from "@mui/icons-material/Verified";
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import HistoryIcon from '@mui/icons-material/History';
import AuditTabComponent from "./AuditTabComponent";
import NewLeadTabComponent from "./NewLeadTabComponent";
import OldLeadTabComponent from "./OldLeadTabComponent";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </div>
  );
};

function AuditLeadComponent() {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && <Loader open={loading} />}
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
      >
        <Tab
          label={`Running`}
          id="tab-0"
          icon={<DirectionsRunIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
        <Tab
          label={`New`}
          id="tab-1"
          icon={<FiberNewIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
        <Tab
          label={`Associated`}
          id="tab-2"
          icon={<HistoryIcon />}
          iconPosition="start"
          aria-controls="tabpanel-2"
        />
      </Tabs>

      <TabPanel value={value} index={0}>
        <AuditTabComponent></AuditTabComponent>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <NewLeadTabComponent></NewLeadTabComponent>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OldLeadTabComponent></OldLeadTabComponent>
      </TabPanel>
    </>
  );
}

export default AuditLeadComponent;
